
import React, {Component} from 'react';
import EventCard from '../../Components/Events/eventCard'
import {connect} from 'react-redux';
import axios from 'axios';
import { css } from "react-emotion";
import { SyncLoader } from "react-spinners";


const getState = (state) =>{
    return{
        url : state.url,
    }
}
const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    margin-top: 40%;
`;
const Dispatch = (dispatch) =>{
    return {
        loadEvents: (data) =>{
            const action = {
                type: 'loadEvents',
                data : data,
            }
            dispatch(action)
        }
    }
}

class ListEventsCards extends Component{
    constructor(props){
        super(props)
        this.state ={
            events:[],
            loading: true,
        }
    }

    componentWillMount = () => {
        let url = this.props.url 
        let loadEvents = this.props.loadEvents
        axios.get(url+'/api/v1/events/client/')
        .then(response =>{
            this.setState({loading: false, events:response.data})
            loadEvents(JSON.stringify(response.data))
        })
    }

    render(){
        return (
            <div className="col-sm-9">
                <center>

                    <SyncLoader
                        className={override}
                        sizeUnit={"px"}
                        size={15}
                        margin={"2px"}
                        color={'#0FA16B'}
                        SyncLoader
                        loading={this.state.loading}
                    />
                </center>
                {
                    this.state.events.map((el,key) =>
                        <EventCard name={el.name}
                            key={key}
                            capacity={el.max_capacity}
                            featuredImage={this.props.url + el.featured_image}
                            available = {el.available}
                            index={key}>
                            {`${el.description.substring(0, 220)}..`}
                        </EventCard>
                    )
                }
            </div>
        )
    }
}

export default connect(getState, Dispatch)(ListEventsCards);



// WEBPACK FOOTER //
// ./src/Pages/ListEvents/ListEvents.js